import { dashboardModules } from '@/api'
import {
  FETCH_DASHBOARD_MARKET_VIEW,
  FETCH_DASHBOARD_RECENT_MENTIONED,
  FETCH_DASHBOARD_SECTOR_SUMMARY,
  FETCH_DASHBOARD_EQUITY_RESEARCH,
  FETCH_DASHBOARD_FOCUS_LIST,
  FETCH_GLOBAL_OUTLOOK,
  FETCH_FEATURE,
  FETCH_DASHBOARD_FOUCS_CHART,
  FETCH_DASHBOARD_FOUCS_CHART_LIST,
  FETCH_DASHBOARD_APAC,
  FETCH_DASHBOARD_COMPANY_INDUSTRY_NOTES,
  FETCH_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL,
  FETCH_DASHBOARD_MONTHLY_REPORTS,
  FETCH_LARGE_CAP,
  FETCH_WHITE_PAPERS,
  FETCH_DASHBOARD_EUROPE,
  FETCH_DASHBOARD_LATAM,
  FETCH_IOP_LISTING,
  FETCH_ECON_SUMMARY,
  FETCH_TREND_WATCH,
  FETCH_ASIA_WATCH,
  FETCH_WON_EUROPE_TODAY,
  FETCH_DERIVATIVES_REPORT,
  FETCH_GLOBAL_LAGGARDS,
  FETCH_WON_GLOBAL_VIEW,
  FETCH_STRATEGY_VIEW,
  SET_VIMEO_THUMBNAIL,
  FETCH_DASHBOARD_WEBINAR,
  FETCH_EREADER,
  FETCH_DASHBOARD_YOUR_EBOOK,
  FETCH_FEATURE_SINGLE_POST,
  FETCH_SECTOR_SPOTLIGHT,
  FETCH_Analyst_Insights_Video_Series 

} from '@/store/actions.type'

import {
  START_LOAD_MARKET_VIEW,
  END_LOAD_MARKET_VIEW,
  SET_RECENT_MENTIONED,
  SET_RECENT_MENTIONED_LOADING,
  LOAD_DASHBOARD_SECTOR_SUMMARY,
  LOAD_DASHBOARD_EQUITY_RESEARCH,
  LOAD_DASHBOARD_FOCUS_LIST,
  LOAD_DASHBOARD_OUTLOOK,
  LOAD_DASHBOARD_FEATURE,
  START_LOAD_FOUCS_CHART,
  START_LOAD_FOUCS_CHART_LIST,
  LOAD_DASHBOARD_APAC,
  LOAD_DASHBOARD_CAFL,
  LOAD_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL,
  LOAD_DASHBOARD_MONTHLY_REPORTS,
  LOAD_DASHBOARD_LARGE_CAP,
  LOAD_DASHBOARD_WHITE_PAPERS,
  LOAD_DASHBOARD_EUROPE,
  LOAD_DASHBOARD_LATAM,
  LOAD_DASHBOARD_IOP_LISTING,
  LOAD_DASHBOARD_ECON_SUMMARY,
  LOAD_DASHBOARD_TREND_WATCH,
  LOAD_DASHBOARD_ASIA_WATCH,
  LOAD_DASHBOARD_WON_EUROPE_TODAY,
  LOAD_DASHBOARD_GLOBAL_LAGGARDS,
  LOAD_DASHBOARD_WON_GLOBAL_VIEW,
  LOAD_DASHBOARD_STRATEGY_VIEW,
  SET_VIMEO_THUMBNAIL_SRC,
  LOAD_DASHBOARD_WEBINAR,
  FETCH_DASHBOARD_CAFL,
  LOAD_DASHBOARD_EREADER,
  LOAD_DASHBOARD_DERIVATIVES_REPORT,
  LOAD_DASHBOARD_YOUREBOOK,
  LOAD_DASHBOARD_FEATURE_POST_SINGLE,
  FETCH_US_MARKET_OVERVIEW,
  LOAD_DASHBOARD_US_MARKET_OVERVIEW,
  LOAD_DASHBOARD_Analyst_Insights_Video_Series,
  LOAD_DASHBOARD_SECTOR_SPOTLIGHT

} from '@/store/mutations.type'

const state = {
  foucschart: {
    data: {
      chartcompare: ''
    }
  },

  marketView: {
    marketViewLoading: false,
    data: {}
  },
  woneuropetoday: {
    data: {}
  },
  recentmentions: {
    isLoading: false,
    data: []
  },
  vimeoimg: {}
}
const actions = {
  async [FETCH_DASHBOARD_FOUCS_CHART]( { commit }, chartid ) {
    return dashboardModules.getfouschart( chartid ).then( ( { data } ) => {
      commit( START_LOAD_FOUCS_CHART, data )
    } )
  },
  async [SET_VIMEO_THUMBNAIL]( { commit }, thumbnailid ) {
    return dashboardModules.getthubnail( thumbnailid ).then( ( { data } ) => {
      commit( SET_VIMEO_THUMBNAIL_SRC, data )
    } )
  },

  async [FETCH_DASHBOARD_FOUCS_CHART_LIST]( { commit } ) {
    return dashboardModules.getFocusListSelect().then( ( { data } ) => {
      commit( START_LOAD_FOUCS_CHART_LIST, data )
    } )
  },
  async [FETCH_DASHBOARD_MARKET_VIEW]( { commit } ) {
    commit( START_LOAD_MARKET_VIEW )
    return dashboardModules.getMarketView().then( ( { data } ) => {
      commit( END_LOAD_MARKET_VIEW, data )
    } )
  },
  async [FETCH_DASHBOARD_RECENT_MENTIONED]( { commit } ) {
    commit( SET_RECENT_MENTIONED_LOADING, true )
    return dashboardModules.getrecentmentions().then( ( { data } ) => {
      commit( SET_RECENT_MENTIONED, data )
      commit( SET_RECENT_MENTIONED_LOADING, false )
    } )
  },
  async [FETCH_DASHBOARD_SECTOR_SUMMARY]( { commit } ) {
    return dashboardModules.getSectorSummary().then( ( { data } ) => {
      commit( LOAD_DASHBOARD_SECTOR_SUMMARY, data )
    } )
  },
  async [FETCH_US_MARKET_OVERVIEW]( { commit } ) {
    return dashboardModules.getdashboardpost( 'us_market_overview_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_US_MARKET_OVERVIEW, data )
    } )
  },

  async [FETCH_Analyst_Insights_Video_Series]( { commit } ) {
    return dashboardModules.getdashboardpost( 'analystinsightsvideoseries_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_Analyst_Insights_Video_Series, data )
    } )
  },


  async [FETCH_SECTOR_SPOTLIGHT]( { commit } ) {
    return dashboardModules.getdashboardpost( 'sector_spotlight_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_SECTOR_SPOTLIGHT, data )
    } )
  },

  async [FETCH_DASHBOARD_EQUITY_RESEARCH]( { commit } ) {
    return dashboardModules.getEquityResearch().then( ( { data } ) => {
      commit( LOAD_DASHBOARD_EQUITY_RESEARCH, data )
    } )
  },
  async [FETCH_DASHBOARD_YOUR_EBOOK]( { commit } ) {
    return dashboardModules.yourebooks( 'your-ebooks' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_YOUREBOOK, data )
    } )
  },
  async [FETCH_DASHBOARD_APAC]( { commit } ) {
    return dashboardModules.getdashboardpost( 'gfl_apac_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_APAC, data )
    } )
  },
  async [FETCH_DASHBOARD_CAFL]( { commit } ) {
    return dashboardModules.getdashboardpost( 'gfl_apac_entitlement1' ).then( ( { data } ) => {
      // console.log("dashboardModules",data)
      commit( LOAD_DASHBOARD_CAFL, data )
    } )
  },
  async [FETCH_DASHBOARD_EUROPE]( { commit } ) {
    return dashboardModules.getdashboardpost( 'gfl_europe_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_EUROPE, data )
    } )
  },
  async [FETCH_DASHBOARD_LATAM]( { commit } ) {
    return dashboardModules.getdashboardpost( 'gfl_latam_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_LATAM, data )
    } )
  },
  async [FETCH_EREADER]( { commit } ) {
    return dashboardModules.getdashboardpost( 'ereader' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_EREADER, data )
    } )
  },

  async [FETCH_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL]( { commit } ) {
    return dashboardModules.getdashboardpost( 'morningcallvideos_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL, data )
    } )
  },

  async [FETCH_DASHBOARD_WEBINAR]( { commit } ) {
    return dashboardModules.getdashboardpost( 'webinars' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_WEBINAR, data )
    } )
  },

  async [FETCH_DASHBOARD_MONTHLY_REPORTS]( { commit } ) {
    return dashboardModules.getdashboardpost( 'monthly-reports' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_MONTHLY_REPORTS, data )
    } )
  },

  async [FETCH_LARGE_CAP]( { commit } ) {
    return dashboardModules.getdashboardpost( 'large_cap_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_LARGE_CAP, data )
    } )
  },

  async [FETCH_WHITE_PAPERS]( { commit } ) {
    return dashboardModules.getdashboardpost( 'white_papers' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_WHITE_PAPERS, data )
    } )
  },

  async [FETCH_IOP_LISTING]( { commit } ) {
    return dashboardModules.getdashboardpost( 'ipo_listing' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_IOP_LISTING, data )
    } )
  },

  async [FETCH_ECON_SUMMARY]( { commit } ) {
    return dashboardModules.getdashboardpost( 'economic_summary' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_ECON_SUMMARY, data )
    } )
  },

  async [FETCH_TREND_WATCH]( { commit } ) {
    return dashboardModules.getdashboardpost( 'trend_watch' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_TREND_WATCH, data )
    } )
  },

  async [FETCH_ASIA_WATCH]( { commit } ) {
    return dashboardModules.getdashboardpost( 'asia_watch ' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_ASIA_WATCH, data )
    } )
  },

  async [FETCH_WON_EUROPE_TODAY]( { commit } ) {
    return dashboardModules.getdashboardpostwoneuropetoday( 'won_europe_today_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_WON_EUROPE_TODAY, data )
    } )
  },
  async [FETCH_DERIVATIVES_REPORT]( { commit } ) {
    return dashboardModules.getdashboardpostderivativesreport( 'derivatives_report_sales_commentary_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_DERIVATIVES_REPORT, data )
    } )
  },

  async [FETCH_GLOBAL_LAGGARDS]( { commit } ) {
    return dashboardModules.getdashboardpost( 'focuslstalertvideos_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_GLOBAL_LAGGARDS, data )
    } )
  },

  async [FETCH_WON_GLOBAL_VIEW]( { commit } ) {
    return dashboardModules.getdashboardpost( 'won_global_view_entitlement' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_WON_GLOBAL_VIEW, data )
    } )
  },

  async [FETCH_STRATEGY_VIEW]( { commit } ) {
    return dashboardModules.getdashboardpost( 'market_intelligence' ).then( ( { data } ) => {
      commit( LOAD_DASHBOARD_STRATEGY_VIEW, data )
    } )
  },

  async [FETCH_DASHBOARD_FOCUS_LIST]( { commit } ) {
    return dashboardModules.getFocusList().then( ( { data } ) => {
      commit( LOAD_DASHBOARD_FOCUS_LIST, data )
    } )
  },
  async [FETCH_GLOBAL_OUTLOOK]( { commit } ) {
    return dashboardModules.getOutlook().then( ( { data } ) => {
      commit( LOAD_DASHBOARD_OUTLOOK, data )
    } )
  },
  async [FETCH_FEATURE]( { commit } ) {
    return dashboardModules.getfeature().then( ( { data } ) => {
      commit( LOAD_DASHBOARD_FEATURE, data )
    } )
  },
  async [FETCH_FEATURE_SINGLE_POST]( { commit } ) {
    return dashboardModules.getfeaturesiglepost().then( ( { data } ) => {
      commit( LOAD_DASHBOARD_FEATURE_POST_SINGLE, data )
    } )
  }
}
const mutations = {
  [START_LOAD_MARKET_VIEW]( state ) {
    state.marketView = {
      marketViewLoading: true,
      data: {}
    }
  },
  [END_LOAD_MARKET_VIEW]( state, marketViewPost ) {
    state.marketView = {
      marketViewLoading: false,
      data: marketViewPost
    }
  },
  [START_LOAD_FOUCS_CHART]( state, foucschart ) {
    state.foucschart = {
      data: foucschart
    }
  },

  [SET_VIMEO_THUMBNAIL_SRC]( state, vimeosrc ) {
    // console.log('vimeosrc', vimeosrc.showThumb)
    state.vimeoimg = vimeosrc[0].thumbnail_medium
  },
  [LOAD_DASHBOARD_EREADER]( state, ereader ) {
    state.ereader = {
      data: ereader
    }
  },

  [LOAD_DASHBOARD_APAC]( state, apac ) {
    state.apac = {
      data: apac
    }
  },
  [LOAD_DASHBOARD_CAFL]( state, cafl ) {
    state.cafl = {
      data: cafl
    }
  },
  [LOAD_DASHBOARD_EUROPE]( state, europe ) {
    state.europe = {
      data: europe
    }
  },
  [LOAD_DASHBOARD_YOUREBOOK]( state, yourebook ) {
    state.yourebook = {
      data: yourebook
    }
  },

  [LOAD_DASHBOARD_LATAM]( state, latam ) {
    state.latam = {
      data: latam
    }
  },

  [LOAD_DASHBOARD_SECTOR_SPOTLIGHT]( state, sectorspotlightdata ) {
    state.sectorspotlight = {
      data: sectorspotlightdata
    }
  },
  [LOAD_DASHBOARD_WON_EUROPE_TODAY]( state, woneuropetoday ) {
    state.woneuropetoday = {
      data: woneuropetoday
    }
  },
  [LOAD_DASHBOARD_DERIVATIVES_REPORT]( state, derivativesreportsdata ) {
    state.derivativesreports = {
      data: derivativesreportsdata
    }
  },
  [LOAD_DASHBOARD_US_MARKET_OVERVIEW]( state, usmarketoverview ) {
    state.usmarketoverview = {
      data: usmarketoverview
    }
  },
  [LOAD_DASHBOARD_Analyst_Insights_Video_Series]( state, analystinsightsData ) {
  
    state.analystinsights = {
      data: analystinsightsData
    }
  },


  
  [LOAD_DASHBOARD_GLOBAL_LAGGARDS]( state, globallaggards ) {
    state.globallaggards = {
      data: globallaggards
    }
  },

  [LOAD_DASHBOARD_WON_GLOBAL_VIEW]( state, wonglobalview ) {
    state.wonglobalview = {
      data: wonglobalview
    }
  },

  [LOAD_DASHBOARD_STRATEGY_VIEW]( state, strategyview ) {
    state.strategyview = {
      data: strategyview
    }
  },

  [LOAD_DASHBOARD_IOP_LISTING]( state, ioplisting ) {
    state.ioplisting = {
      data: ioplisting
    }
  },

  [LOAD_DASHBOARD_ECON_SUMMARY]( state, econsummary ) {
    state.econsummary = {
      data: econsummary
    }
  },

  [LOAD_DASHBOARD_TREND_WATCH]( state, trendwatch ) {
    state.trendwatch = {
      data: trendwatch
    }
  },

  [LOAD_DASHBOARD_ASIA_WATCH]( state, asiawatch ) {
    state.asiawatch = {
      data: asiawatch
    }
  },
  [LOAD_DASHBOARD_FEATURE_POST_SINGLE]( state, featuresinglepost ) {
    state.featuresinglepost = {
      data: featuresinglepost
    }
  },

  [LOAD_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL]( state, researchanalystmorningcall ) {
    state.researchanalystmorningcall = {
      data: researchanalystmorningcall
    }
  },

  [LOAD_DASHBOARD_WEBINAR]( state, webinar ) {
    state.webinar = {
      data: webinar
    }
  },

  [LOAD_DASHBOARD_MONTHLY_REPORTS]( state, monthlyreports ) {
    state.monthlyreports = {
      data: monthlyreports
    }
  },

  [LOAD_DASHBOARD_LARGE_CAP]( state, largecap ) {
    state.largecap = {
      data: largecap
    }
  },

  [LOAD_DASHBOARD_WHITE_PAPERS]( state, whitepapers ) {
    state.whitepapers = {
      data: whitepapers
    }
  },

  [START_LOAD_FOUCS_CHART_LIST]( state, foucschartlist ) {
    state.foucschartlist = {
      data: foucschartlist
    }
  },

  [LOAD_DASHBOARD_SECTOR_SUMMARY]( state, sectorsummaryPost ) {
    state.sectorsummary = {
      data: sectorsummaryPost
    }
  },
  [LOAD_DASHBOARD_OUTLOOK]( state, outlook ) {
    state.outlook = {
      data: outlook
    }
  },

  [LOAD_DASHBOARD_FOCUS_LIST]( state, focuslist ) {
    state.focuslist = {
      data: focuslist
    }
  },
  [LOAD_DASHBOARD_FEATURE]( state, feature ) {
    state.feature = {
      data: feature
    }
  },

  [LOAD_DASHBOARD_EQUITY_RESEARCH]( state, equityResearchPost ) {
    state.equityresearch = {
      data: equityResearchPost
    }
  },
  [SET_RECENT_MENTIONED]( state, recentmentions ) {
    state.recentmentions.data = recentmentions
  },
  [SET_RECENT_MENTIONED_LOADING]( state, loadingStatus ) {
    state.recentmentions.isLoading = loadingStatus
  }
}

const getters = {
  dashboardstate( state ) {
    return state
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js